import { get, post } from "./http";

class API {
  // 测试接口
  ceshi(data) {
    return post(`http://58.87.104.85:9194/admin/login/index`, data);
  }
  // 首页 模考和历年真题
  home(data) {
    return post(`home/question`, data);
  }
  // 首页 模考的用户记录
  mock_home_user(data) {
    return post(`home/question/mock_home_user`, data);
  }
  // 知识点练习 专业与科目
  major(data) {
    return post(`home/question/major`, data);
  }
  // 知识点练习 获取一级知识点列表、默认展开第一个一级知识点
  knowledge(data) {
    return post(`home/question/knowledge`, data);
  }
  // 知识点练习  获取二级知识点
  second(data) {
    return post(`home/question/second`, data);
  }

  // ///////////////////////////////////////////////////////////////////////////////////

  // 列表  【模考】列表
  mock_list(data) {
    return post(`home/question/mock_list`, data);
  }
  // 列表  【历年真题】列表
  real_list(data) {
    return post(`home/question/real_list`, data);
  }
  // 列表  【知识点练习】列表
  knowledge_list(data) {
    return post(`home/question/knowledge`, data);
  }
  // 列表  【练习记录】列表
  practice_list(data) {
    return post(`home/personal/practice_list`, data);
  }
  // 列表  【错题本】列表
  error_list(data) {
    return post(`home/personal/error_list`, data);
  }
  // 列表  【错题本】列表
  error_second(data) {
    return post(`home/personal/error_second`, data);
  }
  // ///////////////////////////////////////////////////////////////////////////////////
  // 模考  开始考试
  mock_start(data) {
    return post(`home/question/mock_start`, data);
  }
  // 模考详情
  mock_detail(data) {
    return post(`home/question/mock_detail`, data);
  }
  // 模考通知二维码
  mock_code(data) {
    return post(`home/question/mock_code`, data);
  }
  // 模考答题
  mock_answer(data) {
    return post(`home/question/mock_answer`, data);
  }
  // 模考 开始补考
  start_repair(data) {
    return post(`home/question/start_repair`, data);
  }
  // 模考答题 提交
  mock_record(data) {
    return post(`home/question/mock_record`, data);
  }
  // 模考 主观题确认提交
  enter_sub(data) {
    return post(`home/question/enter_sub`, data);
  }
  // 模考答题 解析
  mock_analysis(data) {
    return post(`home/question/mock_analysis`, data);
  }
  // 模考查看某人解析
  show_analysis(data) {
    return post(`show_analysis`, data);
  }
  // 模考 删除学习记录
  del_record(data) {
    return post(`home/question/del_record`, data);
  }
  // 模考 结果页 分数排名
  mock_res(data) {
    return post(`home/question/mock_res`, data);
  }
  // 模考 结果页 智能批改 结果
  mock_eng(data) {
    return post(`home/question/mock_eng`, data);
  }
  // 模考 结果页 智能批改 批改动作
  mock_ecc(data) {
    return post(`home/question/mock_ecc`, data);
  }
  // 模考 结果页 分数对比
  mock_obj(data) {
    return post(`home/question/mock_obj`, data);
  }
  // 模考 免费报名
  mock_sign(data) {
    return post(`home/question/mock_sign`, data);
  }
  // 模考 查看批改结果
  eng_res(data) {
    return post(`home/question/eng_res`, data);
  }
  // 模考 查看排名
  mock_rank(data) {
    return post(`home/question/mock_rank`, data);
  }
  // 模考 广告位
  other_poster(data) {
    return post(`home/question/other_poster`, data);
  }
  // 模考 获取倒计时
  answer_time(data) {
    return post(`home/question/answer_time`, data);
  }
  // 模考 云存储
  mock_cloud(data) {
    return post(`home/question/mock_cloud`, data);
  }
  // 模考 成绩分析
  mock_analysis_result(data) {
    return post(`home/question/mock_analysis_result`, data);
  }
  // 模考 结果页
  mock_result_2024(data) {
    return post(`home/question/mock_result_2024`, data);
  }
  // 模考 结果页 我的成绩vs国家线
  country_line(data) {
    return post(`home/question/country_line`, data);
  }
  // 模考 我的模考记录分析报告
  mock_report_ai(data) {
    return post(`home/question/mock_report_ai`, data, 1);
  }
  // 模考 点击ai阅卷，请求接口
  mock_marking_ai(data) {
    return post(`home/question/mock_marking_ai`, data);
  }
  // 模考 考前信息获取地区列表
  area_list(data) {
    return post(`home/question/area_list`, data);
  }
   // 模考 考前信息所属分校列表
  unit_list(data) {
    return post(`home/question/unit_list`, data);
  }
   // 模考 考前信息提交
   mock_user_info(data) {
    return post(`home/question/mock_user_info`, data);
  }
   // 模考 获取ai批改分数
   get_ai_score(data) {
    return post(`home/question/get_ai_score`, data);
  }
  // 模考 考前选择专业 下拉数据
  mock_major(data) {
    return post(`home/question/mock_major`, data);
  }
  // ///////////////////////////////////////////////////////////////////////////////////

  // 历年真题 详情页
  real_intro(data) {
    return post(`home/question/real_info`, data);
  }
  // 历年真题 答题
  start_real(data) {
    return post(`home/question/start_real`, data);
  }
  // 历年真题 提交
  real_record(data) {
    return post(`home/question/real_record`, data);
  }
  // 历年真题 解析
  real_analysis(data) {
    return post(`home/question/real_analysis`, data);
  }
  // 历年真题 查看视频
  ticket(data) {
    return post(`home/course/ticket`, data);
  }
  // ///////////////////////////////////////////////////////////////////////////////////

  // 知识点练习  试题数据
  know_ques(data) {
    return post(`home/question/know_ques`, data);
  }
  // 知识点练习 提交
  know_record(data) {
    return post(`home/question/know_record`, data);
  }
  // 知识点练习 查看解析
  know_analysis(data) {
    return post(`home/question/know_analysis`, data);
  }

  // ///////////////////////////////////////////////////////////////////////////////////

  // 错题本  科目列表
  sub_list(data) {
    return post(`home/personal/sub_list`, data);
  }
  // 错题本  试题数据
  error_question(data) {
    return post(`home/personal/error_question`, data);
  }
  // 错题本  提交
  sub_error(data) {
    return post(`home/question/sub_error`, data);
  }

  // ///////////////////////////////////////////////////////////////////////////////////

  // 退出
  sign_out(data, issign) {
    return post("home/login/sign_out", data, issign);
  }
  // 更新用户信息
  person_up(data, issign) {
    return post("home/personal/info", data, issign);
  }

  // ////////////////////////////////////////////////////////////////////////////////////////////////
  // 关联试卷 获取试卷信息
  correlation_test_data(data) {
    return post("home/correlation/list", data);
  }
  // 关联试卷 提交
  correlation_sub(data) {
    return post("home/correlation/sub_correlation", data);
  }
  // 关联试卷 查看解析
  correlation_analysis(data) {
    return post("home/correlation/corre_analysis", data);
  }
  // ////////////////////////////////////////////////////////////////////////////////////////////////
}

export default new API();
